// @ts-nocheck
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector("div")

  if (!tooltipEl) {
    tooltipEl = document.createElement("div")
    tooltipEl.classList.add("react-chartjs-2-tooltip")

    const container = document.createElement("div")
    container.classList.add("react-chartjs-2-tooltip-container")

    tooltipEl.appendChild(container)
    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}

export const renderTooltip = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context
  const tooltipEl = getOrCreateTooltip(chart)
  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || []
    const bodyDataPoints = tooltip.dataPoints.map(
      ({ formattedValue, dataset: { label } }) => ({
        formattedValue,
        label,
      }),
    )

    const tableHead = document.createElement("div")

    titleLines.forEach((title: string) => {
      const h4 = document.createElement("h4")
      const date = new Date(title)
      const seperatorCount = title
        .split("")
        .reduce((acc, curr) => (curr === "/" ? acc + 1 : acc), 0)
      let tooltipTitleText = title
      // all date segments are present
      if (seperatorCount === 2 && !title.includes("M")) {
        const weekday = WEEKDAYS[date.getDay()]
        tooltipTitleText = `${tooltipTitleText}, ${weekday}`
      }
      const text = document.createTextNode(tooltipTitleText)
      h4.classList.add("tooltip-title")

      h4.appendChild(text)
      tableHead.appendChild(h4)
    })

    const tableBody = document.createElement("div")
    tableBody.classList.add("items-container")
    bodyDataPoints.forEach(({ formattedValue, label }, i) => {
      const colors = tooltip.labelColors[i]

      const colorSquare = document.createElement("span")
      const backgroundFullOpacity = colors.backgroundColor
        .replace("a", "")
        .replace(",0.6", "") // rgba(x,y,z,0.6) to rgb(x, y, z)
      colorSquare.style.background = backgroundFullOpacity
      colorSquare.style.borderRadius = "2px"
      colorSquare.style.marginRight = "4px"
      colorSquare.style.height = "12px"
      colorSquare.style.width = "12px"
      colorSquare.style.display = "inline-block"

      const textContentSpan = document.createElement("div")

      textContentSpan.classList.add("tooltip-item")

      const tooltipItemText = document.createElement("span")
      tooltipItemText.classList.add("tooltip-item-text")

      const labelText = document.createTextNode(label ?? "")
      const formattedValueSpan = document.createElement("span")
      formattedValueSpan.style.fontWeight = "500"
      formattedValueSpan.textContent = formattedValue ?? ""

      tooltipItemText.appendChild(labelText)
      tooltipItemText.appendChild(formattedValueSpan)

      textContentSpan.appendChild(tooltipItemText)
      textContentSpan.prepend(colorSquare)
      tableBody.appendChild(textContentSpan)
    })

    const tableRoot = tooltipEl.querySelector("div")

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove()
    }

    // Add new children
    tableRoot.appendChild(tableHead)
    tableRoot.appendChild(tableBody)
  }

  const { offsetLeft: positionX } = chart.canvas
  const positionY = chart.canvas.getBoundingClientRect().top

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1
  tooltipEl.style.left = positionX + tooltip.caretX + "px"
  tooltipEl.style.top = tooltip.caretY + 5 + positionY + "px"

  tooltipEl.style.font = tooltip.options.bodyFont.string
  tooltipEl.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px"
}

const CHART_COLOR_SCHEME_MAP = {
  total: "#843ae2",
  reply: "#ffc165",
  replies: "#ffc165",
  lead: "#41E6F2",
  leads: "#41E6F2",
  followup: "#22B870",
  "follow ups": "#22B870",
  new: "#FF5757",
  prospects: "#FF5757",
  bounces: "#D97706",

  "unsubscribe email address only": "#FFA07A",
  "unsubscribe company's domain": "#6A5ACD",
  "complicated unsubscribe request": "#FFD700",
  "hostile unsubscribe request": "#00CED1",
  "responds negatively or requests unsubscription": "#FF8C00",

  "irrelevant reply or spam/junk": "#6B7FCC",

  "immediate interest in meeting or connecting": "#FF9B3E",
  "immediate interest, seeks more info": "#4ECDC4",
  "future interest": "#D97EA5",
  "asks only how sender found them": "#B4CCB9",
  "expresses interest, asks polite question or books meeting": "#FF5E5E",

  "polite/neutral disinterest": "#D3D3D3",
  "hostile disinterest": "#666666",
  "disinterest and unsubscribe request": "#999999",
  "polite/neutral disinterest, requires response": "#BBBBBB",
  "polite/neutral disinterest, provides important information": "#AAAAAA",
  "expresses disinterest": "#888888",

  "wrong recipient, provides correct contact": "#FF9999",
  "wrong recipient, forwards to correct contact": "#FF6666",
  "wrong recipient, no contact provided": "#FF3333",
  "wrong recipient, misaddressed email": "#FFCC99",
  "wrong recipient, requires response to question": "#FF9966",
  "wrong recipient, provides important information": "#FF6633",
  "incorrect contact": "#FFCC66",

  "out of office reply": "#A29ECD",
  "other auto-generated reply": "#FFD966",
  "automated response": "#00A8B5",

  "unsure of category": "#FFB74D",
}

export const getChartColorByKey = (key: string) =>
  CHART_COLOR_SCHEME_MAP[key] ?? "#9f9f9f"
